import { InstagramLogo, ArrowRight } from "@phosphor-icons/react";

const galleryImages = [
  {
    id: 1,
    src: "https://static.prod-images.emergentagent.com/jobs/df8219ec-752a-49fc-a15a-f7f7322a223f/images/024201bf4702ab5d583a63e8d88f8c6c421ad79a1fe2914d4b953239f78b26c9.png",
    alt: "Peça em MDF cortada a laser",
    span: "col-span-2 row-span-2",
  },
  {
    id: 2,
    src: "https://static.prod-images.emergentagent.com/jobs/df8219ec-752a-49fc-a15a-f7f7322a223f/images/d8e7d9d41323db4bfced8cf4f11fed52e85910df94a50c34964aae820a7eed2c.png",
    alt: "Garrafa com gravação personalizada",
    span: "col-span-1 row-span-1",
  },
  {
    id: 3,
    src: "https://images.pexels.com/photos/15828169/pexels-photo-15828169.jpeg",
    alt: "Detalhe de gravação em metal",
    span: "col-span-1 row-span-1",
  },
  {
    id: 4,
    src: "https://static.prod-images.emergentagent.com/jobs/df8219ec-752a-49fc-a15a-f7f7322a223f/images/06ef52561b071683ae43988a8aa09117da73594164e8d08904b2ac7f215d566c.png",
    alt: "Insert de jogo personalizado",
    span: "col-span-1 row-span-2",
  },
  {
    id: 5,
    src: "https://images.pexels.com/photos/7254462/pexels-photo-7254462.jpeg",
    alt: "Máquina laser em ação",
    span: "col-span-1 row-span-1",
  },
  {
    id: 6,
    src: "https://images.pexels.com/photos/13625513/pexels-photo-13625513.jpeg",
    alt: "Caixa personalizada em MDF",
    span: "col-span-1 row-span-1",
  },
];

const Gallery = () => {
  return (
    <section 
      id="galeria" 
      className="py-24 px-6 bg-[#0C0D14]"
      data-testid="gallery-section"
    >
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="text-[#D500F9] uppercase tracking-[0.2em] text-sm font-semibold mb-4 block">
            Nosso Trabalho
          </span>
          <h2 className="font-outfit text-3xl sm:text-4xl lg:text-5xl font-bold mb-6">
            <span className="gradient-text">Galeria</span> de Projetos
          </h2>
          <p className="text-[#A0AEC0] text-lg max-w-2xl mx-auto">
            Confira alguns dos nossos trabalhos recentes
          </p>
        </div>

        {/* Gallery Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-12">
          {galleryImages.map((image) => (
            <div
              key={image.id}
              className={`gallery-item rounded-xl overflow-hidden ${image.span}`}
              data-testid={`gallery-item-${image.id}`}
            >
              <img
                src={image.src}
                alt={image.alt}
                className="w-full h-full object-cover min-h-[200px]"
              />
            </div>
          ))}
        </div>

        {/* Instagram CTA */}
        <div className="text-center">
          <a
            href="https://instagram.com/tomicharte"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 px-8 py-4 rounded-full font-semibold text-lg transition-all hover:scale-105"
            style={{
              background: "linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%)",
            }}
            data-testid="instagram-cta"
          >
            <InstagramLogo weight="fill" size={28} />
            <span>Ver Mais no Instagram</span>
            <ArrowRight weight="bold" size={20} />
          </a>
          <p className="text-[#A0AEC0] text-sm mt-4">
            Siga-nos para ver mais projetos e novidades
          </p>
        </div>
      </div>
    </section>
  );
};

export default Gallery;
